/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import HelpIcon from '@mui/icons-material/Help';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { GridSearchIcon } from '@mui/x-data-grid';
import { BTable } from 'components/BTable/BTable';
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from 'components/DatePicker/DatePicker';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import { useMaterialUIController } from "context";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import PageTitle from 'examples/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import { CSVLink } from "react-csv";
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchInvoiceContacts, fetchInvoiceReportData } from 'utils/api';
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from 'utils/generic';
import { genericMessage } from 'utils/genericMessages';
import { useSelector } from "react-redux";
import IconMenu from "components/CustomMaterialMenu/Custom";

import TimelineItem from "components/Icon/TimelineItem";
import EditIcon from '@mui/icons-material/Edit';
import { formatCurrencyAUD } from 'utils/formatCurrency';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};
let SCREEN_RIGHT;
function InvoiceReport() {
  const [rows, setRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [tabledata, setTableData] = useState([]);
  const [showModel, setShowModel] = useState(false)
  const [resetClicked, setResetClicked] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const dispatch = useDispatch()
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [customerReload, setCustomerReload] = useState(false)
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [contact, setContact] = useState([]);
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = React.useState({
    invoiceStatus: "",
    invoiceDuration: "",
    customerName: "",
    filterValues: "",
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
    customTo: new Date(),
    searchParameterList: ['invoiceDate', 'invoiceNumber', 'customerName', 'purchaseOrderNumber', 'dueDate', 'invoiceStatus', 'itemName', 'itemID', 'itemPrice', 'itemQuantity',
      'discountType', 'discountValue', 'discountAmount', 'gst', 'gstType', 'finalAmount', 'totalAmount', 'itemCategory',
      'totalDiscountAmount', 'paymentInstruction', ' invoiceDateString', 'individualItemAmount'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });
  let currency = useSelector((state) => state.currency.currencySymbol);
  const headers = [
    { label: "Invoice Number", key: "invoiceNumber" },
    { label: "Invoice Date", key: "invoiceDateToString" },
    { label: "Customer Name", key: "customerName" },
    { label: "Reference Number", key: "purchaseOrderNumber" },
    { label: "Invoice Status", key: "invoiceStatus" },
    { label: "Due Date", key: "dueDate" },
    // { label: "Account", key: "itemCategory" },
    // { label: "Item Name", key: "itemName" },
    // { label: "Item Price", key: "itemPrice" },
    // { label: "Item Quantity", key: "itemQuantity" },
    // { label: "Discount Type", key: "discountType" },
    // { label: "Discount Amount", key: "discountAmount" },
    // { label: "GST(%)", key: "gst" },
    // { label: "GST Type", key: "gstType" },
    // { label: "Individual Amount", key: "individualItemAmount" },
    { label: "Final Amount", key: "finalAmount" },
    { label: "Total Amount", key: "totalAmount" },
    { label: "Total Discount Amount", key: "totalDiscountAmount" },
    { label: "PaymentInstruction", key: "paymentInstruction" },
  ];

  useEffect(() => {
    (async () => {
      await getRight();
      fetchInvoiceReport();
      fetchInvoiceContact();
    })()
  }, [customerReload])


  async function getRight() {
    let SCREEN_RIGHT = await getScreenRight("Invoice Reports")
    setScreenAccess(SCREEN_RIGHT === 'Full Access')
    if (SCREEN_RIGHT === "Full Access")
      setDisableColor(false)

    else setDisableColor(true)

  }

  const fetchInvoiceReport = () => {
    let toDate = new Date(values.customTo);
    toDate.setUTCHours(0, 0, 0, 0);
    let fromDate = new Date(values.customFrom);
    fromDate.setUTCHours(0, 0, 0, 0);

    if (toDate < fromDate) {
      return showResMsg("To Date should not be less than from date.", 2000, false);
    }
    fetchInvoiceReportData(values, (data) => {
      console.log("datas", data);
      setTotalRows(data.result.Result_Output.totalDocs)
      setRows(data.result.Result_Output.docs);
      setTableData(data.result.export);
    }, dispatch)
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleContactChange = (name) => (event, newValue) => {
    if (newValue) {
      setValues({ ...values, [name]: newValue.label, contactTypeId: newValue.value });
    } else {
      setValues({ ...values, [name]: '', contactTypeId: '' });
    }
  };

  const FilterData = async () => {
    fetchInvoiceReport();
  };

  const ResetData = () => {
    setValues((prevValues) => ({
      ...prevValues,
      searchParameter: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
      invoiceStatus: "",
      invoiceDuration: "",
      customerName: "",
      filterValues: "",
      searchParameterList: ['invoiceDate', 'invoiceNumber', 'customerName', 'purchaseOrderNumber', 'dueDate', 'invoiceStatus', 'itemName', 'itemID', 'itemPrice', 'itemQuantity',
        'discountType', 'discountValue', 'discountAmount', 'gst', 'gstType', 'finalAmount', 'totalAmount', 'itemCategory',
        'totalDiscountAmount', 'paymentInstruction', ' invoiceDateString', 'individualItemAmount'],
    }));
    setResetClicked(true);
  };

  useEffect(() => {
    if (resetClicked) {
      fetchInvoiceReport();
      setResetClicked(false);
    }
  }, [resetClicked]);

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setPerPage(newPerPage);
    setCustomerReload(!customerReload)
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload)
  };

  function exportSwal() {
    setShowModel(false);
    showResMsg(genericMessage.dataExportedSucces, 1000, true)
  }

  const fetchInvoiceContact = async () => {
    await fetchInvoiceContacts(values, (data) => {
      console.log("contact", data);
      setContact(data.Result_Output);
    }, dispatch)
  };
  const handleDateChange = (name) => (date) => {
    setValues({ ...values, [name]: new Date(date) });
  };

  const { tableBorder } = getColorMappings(sidenavColor);
  // var element = document.getElementsByTagName('fieldset');
  // useEffect(() => {
  //   for (let i = 0; i < element.length; i++) {

  //     if (darkMode) {
  //       element[i].style.borderColor = "white";
  //     } else {
  //       element[i].style.borderColor = tableBorder;
  //     }

  //   }
  // }, [showFilters])

  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }
  }, [showFilters])


  useEffect(() => {
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "");
        }
      }
    }

  }, [showFilters])


  const reportCol = [
    {
      // name: "Invoice Number",
      name: <p style={{ fontSize: "12px" }}>Invoice Number</p>,
      selector: row => row.invoiceNumber,
      sortable: true,
      sortField: 'invoiceNumber',
      style: { textAlign: 'left' },
      minWidth: '140px'
    },
    {
      name: <p style={{ textAlign: "center", fontSize: "12px", paddingLeft: "26px" }}>Invoice Date</p>,
      selector: row => row.invoiceDateToString,
      sortable: true,
      sortField: 'invoiceDate',
      center: true,
      minWidth: '160px'
    },
    {
      name: <p style={{ fontSize: "12px" }}>Customer Name</p>,
      selector: row => row.customerName,
      sortable: true,
      sortField: 'customerName',
      center: true,
      minWidth: '140px'
    },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "18px" }}>Reference Number</p>,
      selector: row => row.purchaseOrderNumber,
      sortable: true,
      center: true,
      sortField: 'purchaseOrderNumber',
      minWidth: '180px'
    },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "18px" }}>Invoice Status</p>,
      selector: row => row.invoiceStatus,
      sortable: true,
      sortField: 'invoiceStatus',
      center: true,
      minWidth: '160px',
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.invoiceStatus || "N/A"}
        </span>
      )
    },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "18px" }}>Due Date</p>,
      selector: row => row.dueDate,
      sortable: true,
      sortField: 'dueDate',
      center: true,
      minWidth: '160px'
    },
    // {
    //   // name: "Category",
    //   name: <p style={{ fontSize: "12px" }}>Account</p>,
    //   selector: row => row.itemCategory,
    //   sortable: true,
    //   sortField: 'itemCategory',
    //   minWidth: '140px'
    // },

    // {
    //   name: <p style={{ fontSize: "12px" }}>Item Name</p>,
    //   selector: row => row.itemName,
    //   sortable: true,
    //   sortField: 'itemName',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>{`Item Price (${currency})`}</p>,
    //   selector: row => row.itemPrice,
    //   sortable: true,
    //   sortField: 'itemPrice',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>Item Quantity</p>,
    //   selector: row => row.itemQuantity,
    //   sortable: true,
    //   sortField: 'itemQuantity',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>Discount Type</p>,
    //   selector: row => row.discountType,
    //   sortable: true,
    //   sortField: 'discountType',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>{`Discount Amount (${currency})`}</p>,
    //   selector: row => row.discountAmount,
    //   sortable: true,
    //   sortField: 'discountAmount',
    //   center: true,
    //   minWidth: '160px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>GST(%)</p>,
    //   selector: row => row.gst,
    //   sortable: true,
    //   sortField: 'gst',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>GST Type</p>,
    //   selector: row => row.gstType,
    //   sortable: true,
    //   sortField: 'gstType',
    //   center: true,
    //   minWidth: '140px',
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>{`Individual Amount (${currency})`}</p>,
    //   selector: row => row.individualItemAmount,
    //   sortable: true,
    //   sortField: 'individualItemAmount',
    //   center: true,
    //   minWidth: '160px',
    // },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "30px" }}>{`Final Amount (${currency})`}</p>,
      selector: row => formatCurrencyAUD(row.finalAmount),
      sortable: true,
      sortField: 'finalAmount',
      center: true,
      minWidth: '180px',
    },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "30px" }}>{`Total Amount (${currency})`}</p>,
      selector: row => formatCurrencyAUD(row.totalAmount),
      sortable: true,
      sortField: 'totalAmount',
      center: true,
      minWidth: '180px'
    },
    {
      name: <p style={{ fontSize: "12px", paddingLeft: "30px" }}>{`Total Discount Amount (${currency})`}</p>,
      selector: row => formatCurrencyAUD(row.totalDiscountAmount),
      sortable: true,
      sortField: 'totalDiscountAmount',
      center: true,
      minWidth: '230px'
    },
    {
      // name: "PaymentInstruction",
      name: <p style={{ fontSize: "12px" }}>Payment Instruction</p>,
      selector: row => row.paymentInstruction,
      sortable: true,
      sortField: 'paymentInstruction',
      center: true,
      minWidth: '165px'
    },
    // {
    //   // name: "Action(s)",
    //   name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
    //   // selector: row => row._id,
    //   selector: row => (
    //     <span style={{ fontSize: "12px" }}>{row._id}</span>
    //   ),
    //   center: true,
    //   cell: row => <IconMenu size="small" row={
    //     <>
    //       {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
    //       <Grid style={{ width: "100%" }} item>
    //         <Link
    //           to={`/report/item/${row._id}`} disabled={!screenAccess}
    //         >
    //           <p style={darkMode ? { color: "white" } : { color: "black" }}>
    //             <TimelineItem color="success"
    //               //  icon="edit"
    //               icon={<EditIcon className="actionicon" />}
    //               title="Edit" />
    //             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
    //         </Link>
    //       </Grid>

    //     </>
    //   } />,
    // },

    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/report/item/${row._id}`}
                onClick={() => sessionStorage.setItem("reportType", "InvoiceItems")} // 👈 store value
              >
                <TimelineItem color="success" icon="visibility" title="view" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName=" Invoices Report" />
          <Grid container columnSpacing={2} px={2} mt={2} mb={1} alignItems="center" display="flex" justifyContent="right">
            {showFilters && (
              <Grid item xs={12} md={6} lg={9.2}  >
                {values.invoiceDuration === "Custom" && (
                  <Grid container spacing={1.6} sx={{ display: 'flex', justifyContent: 'start', paddingLeft: '10px' }}>
                    <Grid item xs={6} lg={1.7}>
                      <PickDate
                        selected={new Date(values.customFrom)}
                        onChange={handleDateChange('customFrom')}
                        label="From"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                      />
                    </Grid>
                    <Grid item xs={6} lg={1.7}>
                      <PickDate
                        selected={new Date(values.customTo)}
                        onChange={handleDateChange('customTo')}
                        label="To"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        maxDate={new Date()}

                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            )}

            <Grid item xs={12} md={4} spacing={2} lg={1.4}  >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={"warning"}
                fullWidth
                onClick={() => { setShowFilters(!showFilters) }}
                style={{ height: "38.11px" }}
              >
                {showFilters ? 'Hide Filters' : 'Set Filters'}

              </MDButton>
            </Grid>

            <Grid item xs={12} md={4} spacing={2} lg={1.4} >
              {screenAccess ?
                <MDButton
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  style={{ backgroundColor: "#009cff", color: "#ffffff", height: "38.11px" }}
                  fullWidth
                  onClick={() => { setShowModel(true) }}

                >
                  Export
                </MDButton>
                :
                <MDButton
                  className
                  ={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  style={{ height: "38.11px" }}
                  color={"secondary"}
                  fullWidth

                >

                  Export
                </MDButton>
              }
            </Grid>
          </Grid>
          {showFilters && (
            <MDBox>
              <Grid item xs={12} >
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={2} mx={.1}>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="invoiceDate">Invoice Duration</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            // style={{ minHeight: "3em" }}
                            style={{ height: "38.11px" }}
                            label="Invoice Duration"
                            value={values.invoiceDuration}
                            onChange={handleChange('invoiceDuration')}
                            inputProps={{ shrink: true }}
                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="last7Days"> Last Week  </MenuItem>
                            <MenuItem value="last30Days"> Last 1 Month </MenuItem>
                            <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                            <MenuItem value="Custom"> Custom Date</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="invoiceStatus">Invoice Status</InputLabel>
                          <Select
                            labelId="invoiceStatus-select-label"
                            id="invoiceStatus-select"
                            // style={{ minHeight: "3em" }}
                            style={{ height: "38.11px" }}
                            label="Invoice Status"
                            value={values.invoiceStatus}
                            onChange={(e) => setValues({ ...values, invoiceStatus: e.target.value })}
                          >
                            <MenuItem value="Paid">Paid</MenuItem>
                            <MenuItem value="Unpaid">Unpaid</MenuItem>
                            <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <Autocomplete

                        labelId="contactName-select-label"
                        id="contactName-select"
                        options={contact.map(contact => ({
                          label: contact.customerName,
                          value: contact._id
                        }))}

                        onChange={handleContactChange("customerName")}
                        value={values.customerName}
                        sx={{
                          '& .MuiAutocomplete-inputRoot': {
                            height: "38.11px",
                          }
                        }}
                        renderInput={(params) =>
                          <TextField {...params}
                            label="Customer Name"
                            placeholder="Customer Name"
                            className="ress"
                            inputProps={{
                              ...params.inputProps,
                              maxLength: 25,   // <-- ⭐ Max 25 characters
                            }}

                          />}
                      />
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <TextField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth

                        className='searchButton'
                        placeholder="Search..."
                        size="medium"
                        autoComplete="digital"
                        value={values.filterValues}
                        onChange={handleSearchFilter}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") fetchInvoiceReport();
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment  >
                              <Button style={{ borderRadius: "3px 0.3rem  0.3rem 0px", padding: "3px !important", background: barColor }} variant="contained" onClick={fetchInvoiceReport}>
                                <GridSearchIcon color="white" />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <Link to={"/InvoiceReport"}>
                        <MDButton
                          className="btn-block center-container-btn btn-warning btn-back rightSpace"
                          color="warning"
                          fullWidth
                          onClick={ResetData}
                          style={{ height: "38.11px" }}
                        >
                          Reset
                        </MDButton>
                      </Link>
                    </Grid>
                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                        style={{ height: "38.11px" }}
                      >
                        Apply
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          {/* <CardContent> */}
          <BTable
            columns={reportCol}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          // fixedHeaderScrollHeight="410px"
          // fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
        {showModel &&
          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                  Would you like to export this record?
                </Typography>
                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                  <>
                    <MDButton className="no-button" onClick={() => { setShowModel(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink data={tabledata} headers={headers} filename={"Invoice Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                      <MDButton className="yes-button" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                        Yes
                      </MDButton>

                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        }
      </div>
    </DashboardLayout>
  );
}

export default InvoiceReport;
